var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArounds(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 204,
    height: 204,
    viewBox: "0 0 204 204",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M194 30C194 41.0457 185.046 50 174 50C162.954 50 154 41.0457 154 30C154 18.9543 162.954 10 174 10C185.046 10 194 18.9543 194 30Z",
    stroke: "#4BDACC",
    strokeWidth: 6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50 30C50 41.0457 41.0457 50 30 50C18.9543 50 10 41.0457 10 30C10 18.9543 18.9543 10 30 10C41.0457 10 50 18.9543 50 30Z",
    stroke: "#4BDACC",
    strokeWidth: 6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M122 30C122 41.0457 113.046 50 102 50C90.9543 50 82 41.0457 82 30C82 18.9543 90.9543 10 102 10C113.046 10 122 18.9543 122 30Z",
    stroke: "#4BDACC",
    strokeWidth: 6
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M194 102C194 113.046 185.046 122 174 122C162.954 122 154 113.046 154 102C154 90.9543 162.954 82 174 82C185.046 82 194 90.9543 194 102Z",
    stroke: "#4BDACC",
    strokeWidth: 6
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M50 102C50 113.046 41.0457 122 30 122C18.9543 122 10 113.046 10 102C10 90.9543 18.9543 82 30 82C41.0457 82 50 90.9543 50 102Z",
    stroke: "#4BDACC",
    strokeWidth: 6
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M122 102C122 113.046 113.046 122 102 122C90.9543 122 82 113.046 82 102C82 90.9543 90.9543 82 102 82C113.046 82 122 90.9543 122 102Z",
    stroke: "#4BDACC",
    strokeWidth: 6
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M194 174C194 185.046 185.046 194 174 194C162.954 194 154 185.046 154 174C154 162.954 162.954 154 174 154C185.046 154 194 162.954 194 174Z",
    stroke: "#4BDACC",
    strokeWidth: 6
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M50 174C50 185.046 41.0457 194 30 194C18.9543 194 10 185.046 10 174C10 162.954 18.9543 154 30 154C41.0457 154 50 162.954 50 174Z",
    stroke: "#4BDACC",
    strokeWidth: 6
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M122 174C122 185.046 113.046 194 102 194C90.9543 194 82 185.046 82 174C82 162.954 90.9543 154 102 154C113.046 154 122 162.954 122 174Z",
    stroke: "#4BDACC",
    strokeWidth: 6
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArounds);
export default __webpack_public_path__ + "static/media/arounds.794a0bef56d2d7c4adb11d83113a83ad.svg";
export { ForwardRef as ReactComponent };